import Swiper from 'components/Swiper'
import TextBody from 'components/TextBody'
import TextTitleCompressedHeavy from 'components/TextTitleCompressedHeavy'
import { View } from 'components/View.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import starIcon from 'components/Icon/icons/star.svg'
import React from 'react'
import {
  defineMessages,
  FormattedMessage
} from 'react-intl'
import useSelector from 'modules/component/utils/hooks/useSelector.js'

import { rangeArrayUtil } from 'packages/src'
import formatMessageIntlUtil from 'modules/intl/utils/format-message/index.js'
import useIntl from 'modules/component/utils/hooks/useIntl.js'
import Block from 'components/Block/index.js'

const messages = defineMessages({
  reviewedByName: {
    id: 'CheckExerciseFormReviews.reviewedByName',
    defaultMessage: 'Reviewed by {name}'
  },
  title: {
    id: 'CheckExerciseFormReviews.title',
    defaultMessage: 'What Our Customers Are Saying'
  }
})

const REVIEWS = [
  {
    reviewer: 'Marcus T.',
    text: 'The AI caught my squat depth issue immediately. I’ve been lifting for years and never realized my form was off.'
  },
  {
    reviewer: 'Sarah K.',
    text: 'Finally feel confident lifting alone. It’s like having a personal trainer watching every set.'
  },
  {
    reviewer: 'David P.',
    text: 'My lower back pain disappeared after fixing my deadlift form with the AI feedback. Game changer.'
  },
  {
    reviewer: 'Lisa M.',
    text: 'I can actually see my form improving week by week. The instant feedback keeps me accountable.'
  },
  {
    reviewer: 'James R.',
    text: 'No more guessing if I’m doing it right. The AI gives me clear, actionable corrections.'
  }
]

const REVIEWS_ANALYTIC_EVENT = {
  VIEW_REVIEWER: 'VIEW_REVIEWER_CHECK_EXERCISE_FORM',
  NEXT_REVIEW: 'NEXT_REVIEW_CHECK_EXERCISE_FORM',
  PREVIOUS_REVIEW: 'PREVIOUS_REVIEW_CHECK_EXERCISE_FORM'
}

export function CheckExerciseFormReviews () {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const intl = useIntl()
  return (
    <Block
      style={{
        backgroundColor: 'white'
      }}
    >
      <View centered>
        <TextTitleCompressedHeavy>
          {formatMessageIntlUtil(intl, messages.title)}
        </TextTitleCompressedHeavy>
      </View>
      <Swiper
        style={{
          width: isSmallScreen ? '100%' : 'auto'
        }}
        autoplay
        renderArrows
        rightArrowPressEvent={REVIEWS_ANALYTIC_EVENT.NEXT_REVIEW}
        leftArrowPressEvent={REVIEWS_ANALYTIC_EVENT.PREVIOUS_REVIEW}
      >
        {
          REVIEWS.map(({
            text,
            reviewer
          }) => {
            return (
              <View
                key={reviewer}
                px={isSmallScreen
                  ? 8
                  : 16}
                centered
                h={42}
              >
                <TextTitleCompressedHeavy ta>"{text}"</TextTitleCompressedHeavy>
                <View
                  mt={4}
                  row
                >
                  {rangeArrayUtil(
                    0,
                    5
                  )
                    .map((
                      _,
                      index
                    ) => (
                      <img
                        key={index}
                        src={starIcon}
                        alt=''
                        style={{
                          width: '1.40em',
                          height: '1.40em',
                          marginRight: '0.19em'
                        }}
                      />
                    ))}
                </View>
                <View
                  mt
                  row
                  ac
                >
                  <TextBody>
                    <FormattedMessage
                      {...messages.reviewedByName}
                      values={{
                        name: (
                          <b>
                            <span>
                              {reviewer}
                            </span>
                          </b>
                        )
                      }}
                    />
                  </TextBody>
                </View>
              </View>
            )
          })
        }
      </Swiper>
    </Block>
  )
}
